import { mapActions, mapGetters, mapMutations } from "vuex";
import { ONBOARDING_STEPS } from "../constant";
export const RELEASEME_MODULE_NAME = "releaseme";

export const RELEASEME_MODAL_ACTIONS = {
  EMAIL_DOCUMENT: "Email_documents",
  ONBOARDING: "ONBOARDING",
  ADD_PROJECT: "ADD_PROJECT",
  RELEASEME_ONBOARDING: "RELEASEME_ONBOARDING ",
  CREATE_CONTRACT: "CREATE_CONTRACT",
  SIGN_CONTRACT: "SIGN_CONTRACT",
  SIGN_SAMPLE_CONTRACT: "SIGN_SAMPLE_CONTRACT",
  FINISH_ONBOARDING: "FINISH_ONBOARDING",
  MOBILE_CREATE_CONTRACT: "MOBILE_CREATE_CONTRACT",
  PREFERENCES: "PREFERENCES",
};

const initState = {
  is_connected: false,
  releases: {
    contract_templates: [],
    applicable_medias: [],
    restrictions: [],
    terms: [],
    territories: [],
    tags: [],
  },
  archives: [],
  imports: [],
  modal: null,
  selected_contract: null,

  // for update
  contract_template: null,
  contract_file: null,
  isLoading: { index: true },
  onboarding_current_step: ONBOARDING_STEPS.STEP_1,
  onboarding_actions_performed: [],
  sample_project: null,
  onboarding_metadata: null,
  selected_preferences: [],
  selected_preference_categories: [],
};

const ReleaseMEModule = {
  namespaced: true,
  state: () => initState,
  mutations: {
    // COMMON
    RESET(state) {
      state.is_connected = false;
      state.releases = {
        contract_templates: [],
      };
      state.archives = [];
      state.imports = [];
    },
    connected(state, flag) {
      state.is_connected = flag;
    },

    // RELEASE LIST
    index(state, { body: releases, params }) {
      state.releases = releases;
      state.isLoading.index = false;
    },

    // ARCHIVE RELEASE LIST
    index_archive(state, { body: releases, params }) {
      state.archives = releases;
    },

    // IMPORT RELEASE LIST
    index_importable(state, { body: releases, params }) {
      state.imports = releases;
    },

    show(state, { body: data }) {
      state.contract_template = data;
    },

    archive_releases(state, release) {
      const index = state.releases.contract_templates.findIndex(
        (r) => r.contract_template_hashid === release.contract_template_hashid
      );
      if (index > -1) {
        state.releases.contract_templates.splice(index, 1);
        state.archives.push(release);
      }
    },

    destroy(state, { body: releases, params }) {
      const index = state.releases.contract_templates.findIndex(
        (r) => r.contract_template_hashid === params.contract_template_hashid
      );
      if (index > -1) {
        state.releases.contract_templates.splice(index, 1);
      }
    },
    update_star(state, { body, params }) {
      let release = state.releases.contract_templates.find(
        (r) => r.contract_template_hashid === params.contract_template_hashid
      );
      if (release) {
        release.starred = params.starred;
      }
    },
    modalData(state, data) {
      if (state.modal && state.modal.action === RELEASEME_MODAL_ACTIONS.EMAIL_DOCUMENT) {
        state.selected_contract = null;
      }
      state.modal = (typeof data === "string" ? { action: data } : data) || null;
    },
    upload_file(state, body) {
      state.contract_file = body;
      console.log("contract file", body);
    },

    emailDocument(state, template) {
      state.selected_contract = template;
    },

    unarchive_releases(state, ids) {
      ids.forEach((id) => {
        const index = state.archives.findIndex((a) => a.id === id);
        if (index > -1) {
          state.releases.contract_templates.push(state.archives[index]);
          state.archives.splice(index, 1);
          state.releases.contract_templates.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
      });
    },
    setLoading(state, { action: action_name, flag = true }) {
      state.isLoading[action_name] = flag;
    },
    goToStep(state, { step }) {
      state.onboarding_current_step = step;
      console.log("CStep", state.onboarding_current_step, step);
    },

    nextStep(state) {
      const nextStepMapping = {
        [ONBOARDING_STEPS.STEP_1_1]: ONBOARDING_STEPS.STEP_2,
        [ONBOARDING_STEPS.STEP_3_1]: ONBOARDING_STEPS.STEP_4,
        [ONBOARDING_STEPS.STEP_3]: ONBOARDING_STEPS.STEP_3_1,
        [ONBOARDING_STEPS.STEP_5]: ONBOARDING_STEPS.STEP_5,
        [ONBOARDING_STEPS.STEP_6]: ONBOARDING_STEPS.STEP_6,
        [ONBOARDING_STEPS.STEP_7]: ONBOARDING_STEPS.STEP_7,
      };
      state.onboarding_current_step =
        nextStepMapping[state.onboarding_current_step] || state.onboarding_current_step + 1;
    },

    previousStep(state) {
      const previousStepMapping = {
        [ONBOARDING_STEPS.STEP_1]: ONBOARDING_STEPS.STEP_1,
        [ONBOARDING_STEPS.STEP_1_1]: ONBOARDING_STEPS.STEP_1,
        [ONBOARDING_STEPS.STEP_3_1]: ONBOARDING_STEPS.STEP_3,
        [ONBOARDING_STEPS.STEP_4]: ONBOARDING_STEPS.STEP_3_1,
        [ONBOARDING_STEPS.STEP_5]: ONBOARDING_STEPS.STEP_4,
        [ONBOARDING_STEPS.STEP_6]: ONBOARDING_STEPS.STEP_5,
        [ONBOARDING_STEPS.STEP_7]: ONBOARDING_STEPS.STEP_6,
      };

      state.onboarding_current_step =
        previousStepMapping[state.onboarding_current_step] || state.onboarding_current_step - 1;
    },
    addOnboardingActionPerformed(state, action) {
      state.onboarding_actions_performed = [...state.onboarding_actions_performed, action];
    },
    setSampleProject(state, project) {
      state.sample_project = project;
    },
    setMetaData(state, data) {
      console.log("Meta data", data);
      state.onboarding_metadata = data;
      localStorage.setItem("onboarding_metadata", JSON.stringify(data));
    },
    setSelectedPreferences(state, preferences) {
      state.selected_preferences = preferences;
    },
    setSelectedPreferenceCategories(state, categories) {
      console.log("categories", categories);
      state.selected_preference_categories = categories;
    },
  },
  actions: {
    // close - this.manageModal();
    // add - this.manageModal("add")
    // edit - this.manageModal("edit")
    // OR edit - this.manageModal({action: "edit", payload: "dad23dg34"})
    manageModal({ commit }, data) {
      console.log("Action", data);
      commit("modalData", data);
      $("#releaseme-modal").modal(data ? "show" : "hide");
    },
  },
  getters: {
    is_connected: (s) => s.is_connected,

    releases: (s) => s.releases,

    imports: (s) => s.imports,
    archives: (s) => s.archives,

    modal: (s) => s.modal,

    contract_template: (s) => s.contract_template,

    selected_contract: (s) => s.selected_contract,
    contract_file: (s) => s.contract_file,
    isLoading: (s) => s.isLoading,
    onboarding_current_step: (s) => s.onboarding_current_step,
    onboarding_actions_performed: (s) => s.onboarding_actions_performed,
    sample_project: (s) => s.sample_project,
    onboarding_metadata: (s) => s.onboarding_metadata,
    selected_preferences: (s) => s.selected_preferences,
    selected_preference_categories: (s) => s.selected_preference_categories,
  },
};

export const mapReleaseMEActions = (data) => mapActions(RELEASEME_MODULE_NAME, data);
export const mapReleaseMEGetters = (data) => mapGetters(RELEASEME_MODULE_NAME, data);

export const mapReleaseMEMutations = (data) => mapMutations(RELEASEME_MODULE_NAME, data);

export default ReleaseMEModule;
